<template lang="pug">
.pho-clipboard(ref="phoClipboardRef")
  v-tooltip(bottom)
    template(v-slot:activator="{ on, attrs }")
      v-btn.pho-clipboard-button(v-bind="attrs" v-on="on" @click="copyText")
        v-icon content_copy
    span {{ tooltipText }}
</template>

<script>
import { useContext } from '@/compat';
import { ref, computed } from 'vue';
import useClipboard from '@/helpers/misc/useClipboard';

export default {
  name: 'PhoClipboardButton',
  props: {
    tooltip: {
      type: String,
      required: false,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { $i18n, $lang } = useContext();
    const phoClipboardRef = ref(null);

    const tooltipText = computed(() => (
      props.tooltip || $i18n.t($lang.app.COPY_TO_CLIPBOARD)
    ));

    const { copy } = useClipboard();

    const copyText = () => {
      copy(props.content, phoClipboardRef.value);
    };

    return {
      phoClipboardRef,
      copyText,
      tooltipText,
    };
  },
};
</script>
